import { api } from "lib/api";
import Footer from "shared/Footer";
import Meta from "shared/Meta";
import Nav from "shared/Nav";
import PostCard from "shared/PostCard";
import Link from "next/link";
import { useState } from "react";

export default function ArticlesPage({ settings, tags, posts }) {
  const [showMenu, setShowMenu] = useState(false);
  return (
    <>
      <Meta settings={settings} />
      <Nav settings={settings} />
      <div className="container mx-auto my-8">
        <div className="relative md:hidden flex items-end justify-end">
          <button
            className="z-20 mx-4 rounded shadow-xl p-2 bg-gradient-to-tr from-blue-500 to-blue-900 text-white"
            onClick={() => setShowMenu(!showMenu)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
              />
            </svg>
          </button>
          <div
            onClick={() => {
              if (showMenu) {
                setShowMenu(false);
              }
            }}
            className={`p-4 bg-white rounded shadow-xl top-4 left-0 ${
              showMenu ? "absolute z-10" : "hidden"
            }`}
          >
            <Link href="/articles">
              <a className="text-blue-900 font-medium underline mb-4">All Articles</a>
            </Link>
            <div className="grid grid-cols-3 md:grid-cols-2">
              {tags?.map((tag) => (
                <Link href={`/articles?tag=${tag.slug}`} key={tag.id}>
                  <a className=" mb-1 text-gray-500 flex items-center justify-center text-center tracking-tighter leading-none">
                    {tag.name}
                  </a>
                </Link>
              ))}
            </div>
          </div>
        </div>
        <div className="md:flex px-4 md:px-0">
          <div className="md:w-1/4">
            <div className="hidden md:flex items-center flex-col">
              <Link href="/articles">
                <a className="text-blue-900 font-medium underline mb-2">All Articles</a>
              </Link>
              <div className="grid grid-cols-3 gap-1 md:grid-cols-2">
                {tags?.map((tag) => (
                  <Link href={`/articles?tag=${tag.slug}`} key={tag.id}>
                    <a className="mx-2 text-sm text-gray-600 underline">{tag.name}</a>
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <div className="md:w-3/4 min-h-[400px]">
            <h1 className="text-4xl mb-4">Articles</h1>
            <div className="grid  grid-cols-1 md:grid-cols-2">
              {posts?.map((post) => (
                <div className="mr-2 mb-4" key={post.id}>
                  <PostCard post={post} key={post.id} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer settings={settings} />
    </>
  );
}

export async function getServerSideProps(context) {
  const { query } = context;
  const settings = await api.getSettings();

  const posts = await api.getPostsByTag(query?.tag);
  const tags = await api.getAllTags();
  return {
    props: {
      settings,
      posts,
      tags,
    },
  };
}
